// import { useNavigate } from "react-router-dom";

// const EmailVerifiedNotice = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-lime-100 to-lime-300 p-6">
//       <div className="max-w-3xl bg-white rounded-xl shadow-lg p-10 text-center space-y-6">
//         <h1 className="text-4xl font-extrabold text-black">Email Verified!</h1>
//         <p className="text-lg text-black font-bold text-start">
//           Your email has been verified. Please wait for the admin's approval of
//           your membership registration. You will receive your User ID and
//           Password via your verified email from the admin.
//         </p>
//         <p className="text-lg text-black font-bold text-start">
//           Please, use your credentials to log in. Once logged in, complete your
//           membership registration fee to unlock your dashboard and become an
//           official member of RGCC.
//         </p>
//         <button
//           onClick={() => navigate("/login")}
//           className="mt-6 bg-lime-400 hover:bg-black hover:text-white transition px-8 py-3 rounded-full font-bold text-lg"
//         >
//           Go to Login
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmailVerifiedNotice;
import { useNavigate } from "react-router-dom";

const EmailVerifiedNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-lime-100 to-lime-300 p-6">
      <div className="max-w-3xl bg-white rounded-xl shadow-lg p-10 text-center space-y-6">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h1 className="text-4xl font-extrabold text-black">
          Registration Submitted Successfully!
        </h1>
        <div className="space-y-4 text-left">
          <p className="text-lg text-black font-bold">
            ✅ Your email has been verified and your registration has been
            submitted.
          </p>
          <p className="text-lg text-black font-bold">
            📋 Your application is now pending admin approval.
          </p>
          <p className="text-lg text-black font-bold">
            📧 You will receive your User ID and Password via email once the
            admin approves your membership.
          </p>
          <p className="text-lg text-black font-bold">
            💳 After receiving your credentials, log in and complete your
            membership registration fee to unlock your dashboard and become an
            official member of RGCC.
          </p>
        </div>
        <div className="flex space-x-4 justify-center mt-6">
          <button
            onClick={() => navigate("/")}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-3 rounded-full font-bold transition"
          >
            Return Home
          </button>
          <button
            onClick={() => navigate("/login")}
            className="bg-lime-400 hover:bg-black hover:text-white px-6 py-3 rounded-full font-bold transition"
          >
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerifiedNotice;
